// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
}

* {
  font-family: 'Roboto' !important;
}

:root {
  --cor-roxoEscuro: #8e58bf;
  --cor-roxoClaro: #ece6f0;
  --cor-roxoApoio: #5d2c8e;
  --cor-roxoBorda: #65558f;
  --cor-roxoTabela: #8e59bf99;
  --cor-roxoColocados: #be81f6ad;
  --cor-vermelho: #c83333;
  --cor-verde: #478933;
  --cor-azul: #0f73d1;
  --cor-brancoTabela: #f1f0f5;
  --cor-branco: #FFFFFF;
  --cor-roxoUltimosColocados: #e7ccff;
  --cor-cinzaPerfil: #f0e7ff;
  --cor-cinzaMargin: #c9c9c9;
  --cor-roxoInput: #f5f0f9;
  --cor-roxoEscuroTabela: #65558F09;
  --cor-preto: #333333;
  --cor-pretoApoio: #4c4452;
  --cor-roxoPastel: #F7F2FA;
  --cor-cinzaAlunos: #dddbe5;
  --cor-cinzaApoio: #B2A8B8FF;
  --cor-pretoForte: #000;
  --cor-pretoTitulo: #1e1e1e;
  --cor-cinzaCard: #404040;
  --cor-pretoFraco: #222;
  --cor-cinzaLinhaTabela: #8e58bf17;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,mCAAmC;EACnC,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,iCAAiC;AACnC","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n}\n\n* {\n  font-family: 'Roboto' !important;\n}\n\n:root {\n  --cor-roxoEscuro: #8e58bf;\n  --cor-roxoClaro: #ece6f0;\n  --cor-roxoApoio: #5d2c8e;\n  --cor-roxoBorda: #65558f;\n  --cor-roxoTabela: #8e59bf99;\n  --cor-roxoColocados: #be81f6ad;\n  --cor-vermelho: #c83333;\n  --cor-verde: #478933;\n  --cor-azul: #0f73d1;\n  --cor-brancoTabela: #f1f0f5;\n  --cor-branco: #FFFFFF;\n  --cor-roxoUltimosColocados: #e7ccff;\n  --cor-cinzaPerfil: #f0e7ff;\n  --cor-cinzaMargin: #c9c9c9;\n  --cor-roxoInput: #f5f0f9;\n  --cor-roxoEscuroTabela: #65558F09;\n  --cor-preto: #333333;\n  --cor-pretoApoio: #4c4452;\n  --cor-roxoPastel: #F7F2FA;\n  --cor-cinzaAlunos: #dddbe5;\n  --cor-cinzaApoio: #B2A8B8FF;\n  --cor-pretoForte: #000;\n  --cor-pretoTitulo: #1e1e1e;\n  --cor-cinzaCard: #404040;\n  --cor-pretoFraco: #222;\n  --cor-cinzaLinhaTabela: #8e58bf17;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
